import axios from "axios";
import {
  LOGIN_USER,
  // LOGGED_IN_USER,
  REGISTER_USER,
  AUTH_USER,
  LOGOUT_USER,
  ADD_TO_CART_USER,
  EDIT_PRODUCT,
  GET_CART_ITEMS_USER,
  REMOVE_CART_ITEM_USER,
  ON_SUCCESS_BUY_USER,
  // GLOGIN_USER,
  FLOGIN_USER,
} from "./types";
// import { USER_SERVER } from "../components/Config.js";
const USER_SERVER = "/api/users";
export function registerUser(dataToSubmit) {
  const request = axios
    .post(`${USER_SERVER}/register`, dataToSubmit)
    .then((response) => response.data);

  return {
    type: REGISTER_USER,
    payload: request,
  };
}

export function loginUser(dataToSubmit) {
  const request = axios
    .post(`${USER_SERVER}/login`, dataToSubmit)
    .then((response) => response.data);

  return {
    type: LOGIN_USER,
    payload: request,
  };
}
// export function gLoginUser(response) {
//   console.log("google respo", response);
//   const request = axios
//     .post(`${USER_SERVER}/glogin`, response)
//     .then((response) => response.data);

//   return {
//     type: GLOGIN_USER,
//     payload: request,
//   };
// }

export function fLoginUser(response) {
  //   console.log(res);
  const request = axios
    .post(`${USER_SERVER}/flogin`, response)
    .then((response) => response.data);

  return {
    type: FLOGIN_USER,
    payload: request,
  };
}

export function auth() {
  const request = axios
    .get(`${USER_SERVER}/auth`)
    .then((response) => response.data);

  return {
    type: AUTH_USER,
    payload: request,
  };
}

export function logoutUser() {
  // const request = axios
  //   .get(`${USER_SERVER}/logout`)
  //   .then((response) => response.data);

  return {
    type: LOGOUT_USER,
    payload: null,
  };
}

export function addToCart(_id) {
  const request = axios
    .get(`${USER_SERVER}/addToCart?productId=${_id}`)
    .then((response) => response.data);

  return {
    type: ADD_TO_CART_USER,
    payload: request,
  };
}

export function editProduct(_id) {
  // console.log("editProduct$$$$$", _id);
  const request = axios
    .get(`/api/product/editProduct?pid=${_id}`)
    .then((response) => response.data);

  return {
    type: EDIT_PRODUCT,
    payload: request,
  };
}

export function getCartItems(cartItems, userCart) {
  const request = axios
    .get(`/api/product/products_by_id?id=${cartItems}&type=array`)
    .then((response) => {
      //Make CartDetail inside Redux Store
      // We need to add quantity data to Product Information that come from Product Collection.
      // console.log("))))))))))", userCart);
      userCart.forEach((cartItem) => {
        response.data.forEach((productDetail, i) => {
          if (cartItem.id === productDetail._id) {
            response.data[i].quantity = cartItem.quantity;
          }
        });
      });

      return response.data;
    });

  return {
    type: GET_CART_ITEMS_USER,
    payload: request,
  };
}

export function removeCartItem(id) {
  const request = axios
    .get(`/api/users/removeFromCart?_id=${id}`)
    .then((response) => {
      response.data.cart.forEach((item) => {
        response.data.cartDetail.forEach((k, i) => {
          if (item.id === k._id) {
            response.data.cartDetail[i].quantity = item.quantity;
          }
        });
      });
      return response.data;
    });

  return {
    type: REMOVE_CART_ITEM_USER,
    payload: request,
  };
}

export function onSuccessBuy(data) {
  const request = axios
    .post(`${USER_SERVER}/successBuy`, data)
    .then((response) => response.data);

  return {
    type: ON_SUCCESS_BUY_USER,
    payload: request,
  };
}
